/** Catering module URL prefix */
export const CATERING_BASE = '/catering';

export const cateringPaths = {
  // Hub
  hub: CATERING_BASE,
  /** Where the Catering side-nav parent lands: forwards to the first sub-page the employee can open. */
  start: `${CATERING_BASE}/start`,
  // Settings
  settings: `${CATERING_BASE}/settings`,
  /** Settings page, scrolled to the Package Tags card (where tags are created and renamed). */
  settingsPackageTags: `${CATERING_BASE}/settings#package-tags`,
  // Packages
  packages: `${CATERING_BASE}/packages`,
  packagesCreate: `${CATERING_BASE}/packages/create`,
  packageEdit: (id: string) => `${CATERING_BASE}/packages/${id}/edit`,
  // Orders
  orders: `${CATERING_BASE}/orders`,
  ordersCreate: `${CATERING_BASE}/orders/create`,
  prepList: `${CATERING_BASE}/prep-list`,
  orderDetail: (id: string) => `${CATERING_BASE}/orders/${id}`,
  orderEdit: (id: string) => `${CATERING_BASE}/orders/${id}/edit`,
  // Orders — documents
  orderBEO: (id: string) => `${CATERING_BASE}/orders/${id}/beo`,
  orderPackSheet: (id: string) => `${CATERING_BASE}/orders/${id}/pack-sheet`,
  orderLabels: (id: string) => `${CATERING_BASE}/orders/${id}/labels`,
  orderPrepList: (id: string) => `${CATERING_BASE}/orders/${id}/prep-list`,
  // Invoices
  invoices: `${CATERING_BASE}/invoices`,
  invoicesCreate: `${CATERING_BASE}/invoices/create`,
  invoiceDetail: (id: string) => `${CATERING_BASE}/invoices/${id}`,
  invoiceEdit: (id: string) => `${CATERING_BASE}/invoices/${id}/edit`,
  invoiceReview: (id: string) => `${CATERING_BASE}/invoices/${id}/review`,
  // Calendar
  calendar: `${CATERING_BASE}/calendar`,
  // Leads
  leads: `${CATERING_BASE}/leads`,
  leadsCreate: `${CATERING_BASE}/leads/create`,
  leadDetail: (id: string) => `${CATERING_BASE}/leads/${id}`,
  leadEdit: (id: string) => `${CATERING_BASE}/leads/${id}/edit`,
  leadAnalytics: `${CATERING_BASE}/leads/analytics`,
  inquiryFormConfig: `${CATERING_BASE}/leads/inquiry-form`,
  beoTemplates: `${CATERING_BASE}/settings/beo-templates`,
  // Recurring Orders
  recurringOrders: `${CATERING_BASE}/orders/recurring`,
  recurringOrdersCreate: `${CATERING_BASE}/orders/recurring/create`,
  recurringOrderEdit: (id: string) => `${CATERING_BASE}/orders/recurring/${id}/edit`,
  // Estimates
  estimates: `${CATERING_BASE}/estimates`,
  estimatesCreate: `${CATERING_BASE}/estimates/create`,
  estimateDetail: (id: string) => `${CATERING_BASE}/estimates/${id}`,
  estimateEdit: (id: string) => `${CATERING_BASE}/estimates/${id}/edit`,
  // Customers
  customers: `${CATERING_BASE}/customers`,
  customerDetail: (id: string) => `${CATERING_BASE}/customers/${id}`,
  customerEdit: (id: string) => `${CATERING_BASE}/customers/${id}/edit`,
  // Email Templates
  emailTemplates: `${CATERING_BASE}/email-templates`,
} as const;
